// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_transcript__HJ6jM {
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
}
.styles_transcript__HJ6jM .styles_singleSegment__vxYcO {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
}
.styles_transcript__HJ6jM .styles_singleSegment__vxYcO .styles_counterMarker__Zyehd {
  margin-top: 8px;
  font-size: 12px;
  background-color: #6ba7a8;
  font-weight: 700;
  color: #fff;
  height: 30px;
  width: 30px;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 100%;
}
.styles_transcript__HJ6jM .styles_singleSegment__vxYcO .styles_counterMarker__Zyehd.styles_emptySpeaker__eLpaL {
  background-color: red;
}

.styles_contentWrapper__YKdvH {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
@media screen and (min-width: 992px) {
  .styles_contentWrapper__YKdvH {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    gap: 3rem;
  }
}
.styles_contentWrapper__YKdvH .styles_transcriptWrapper__mJ31L {
  order: 2;
}
@media screen and (min-width: 992px) {
  .styles_contentWrapper__YKdvH .styles_transcriptWrapper__mJ31L {
    grid-column: span 7;
    order: 1;
  }
}
.styles_contentWrapper__YKdvH .styles_sidebar__yYOnK {
  display: flex;
  flex-direction: column;
  gap: 24px;
  order: 1;
}
@media screen and (min-width: 992px) {
  .styles_contentWrapper__YKdvH .styles_sidebar__yYOnK {
    grid-column: span 3;
    order: 2;
  }
}

.styles_mediaWrapper__q58UM {
  background-color: #6ba7a8;
  padding: 8px;
  border-radius: 12px;
  z-index: 2;
  display: flex;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}
.styles_mediaWrapper__q58UM .styles_mediaContainer__RcEC8 {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}
.styles_mediaWrapper__q58UM .styles_mediaContainer__RcEC8 .styles_media__Hf4k\\+ {
  width: 100%;
}
.styles_mediaWrapper__q58UM .styles_mediaContainer__RcEC8 .styles_button__tjEkL {
  color: #fff;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
}

.styles_wordLevelDisplay__toWGk {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background-color: transparent;
  border: none;
}

.styles_speakerGroup__cjB2R {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}

.styles_messageNumber__OBPv4 {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #6ba7a8;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 12px;
  flex-shrink: 0;
}

.styles_messageBubble__xHUaF {
  background-color: #fafafa;
  border: 1px solid #6ba7a8;
  border-radius: 8px;
  padding: 12px 16px;
  flex: 1 1;
  margin-left: 8px;
}

.styles_speakerName__IFYfH {
  font-weight: 600;
  color: #333;
  font-size: 0.9rem;
  margin-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 4px;
}

.styles_wordsContainer__1IdGJ {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  line-height: 1.6;
}

.styles_word__iMeIH {
  display: inline-block;
  padding: 2px 4px;
  margin: 0 1px;
  cursor: pointer;
  transition: all 0.15s ease;
  border-radius: 3px;
  position: relative;
}
.styles_word__iMeIH:hover {
  background-color: rgba(33, 150, 243, 0.15);
  transform: translateY(-1px);
}
.styles_word__iMeIH.styles_wordPlaying__OGLV0 {
  background-color: #2196f3;
  color: white;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(33, 150, 243, 0.3);
  transform: translateY(-1px) scale(1.05);
  animation: styles_pulse__3CUxh 0.5s ease-in-out;
}
.styles_word__iMeIH.styles_wordEditing__zG0pT {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 3px;
}

.styles_wordInput__jV8yN {
  background: transparent;
  border: none;
  outline: none;
  font-size: inherit;
  font-family: inherit;
  color: inherit;
  padding: 0;
  margin: 0;
  width: 100%;
  min-width: 20px;
}
.styles_wordInput__jV8yN:focus {
  outline: none;
}

.styles_contextMenu__1t8yY {
  position: fixed;
  z-index: 1000;
  pointer-events: auto;
}

.styles_contextMenuContent__dqGuP {
  background: #1976d2;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
}
.styles_contextMenuContent__dqGuP::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #1976d2;
}

.styles_contextMenuItem__68Y3U {
  background: transparent;
  border: none;
  color: white;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}
.styles_contextMenuItem__68Y3U:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.styles_contextMenuItem__68Y3U svg {
  display: block;
}

@keyframes styles_pulse__3CUxh {
  0% {
    transform: translateY(-1px) scale(1);
  }
  50% {
    transform: translateY(-1px) scale(1.08);
  }
  100% {
    transform: translateY(-1px) scale(1.05);
  }
}
.styles_searchReplacePanel__VyQ2X {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #ddd;
  position: fixed;
  bottom: 0.5rem;
  left: 0.5rem;
  z-index: 1000;
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1));
}

.styles_searchReplaceControls__UqXDm {
  display: flex;
  gap: 1rem;
}
.styles_searchReplaceControls__UqXDm input {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  flex: 1 1;
}
.styles_searchReplaceControls__UqXDm button {
  padding: 0.5rem 1rem;
  background-color: #6ba7a8;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.styles_searchReplaceControls__UqXDm button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.styles_searchReplaceControls__UqXDm button:hover:not(:disabled) {
  background-color: #6ba7a8;
}

.styles_searchReplaceToggle__hFeHG {
  padding: 0.5rem;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 999px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.styles_searchReplaceToggle__hFeHG svg {
  width: 16px;
  height: 16px;
  color: #6ba7a8;
}
.styles_searchReplaceToggle__hFeHG:hover {
  background-color: #e9ecef;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/Transcript/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;EACA,2BAAA;EACA,QAAA;AACJ;AACI;EACE,eAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACN;AACM;EACE,qBAAA;AACR;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;AAEE;EAJF;IAKI,aAAA;IACA,sCAAA;IACA,SAAA;EACF;AACF;AACE;EACE,QAAA;AACJ;AAAI;EAFF;IAGI,mBAAA;IACA,QAAA;EAGJ;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,QAAA;AAEJ;AADI;EALF;IAMI,mBAAA;IACA,QAAA;EAIJ;AACF;;AAAA;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,mDAAA;AAGF;AAFE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAIJ;AAHI;EACE,WAAA;AAKN;AAHI;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAKN;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,6BAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;AACF;AACE;EACE,0CAAA;EACA,2BAAA;AACJ;AAGE;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;EACA,uCAAA;EACA,+CAAA;AADJ;AAKE;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;AAHJ;;AAOA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AAJF;AAME;EACE,aAAA;AAJJ;;AASA;EACE,eAAA;EACA,aAAA;EACA,oBAAA;AANF;;AASA;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,0CAAA;EACA,kBAAA;AANF;AAQE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;AANJ;;AAUA;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;AAPF;AASE;EACE,0CAAA;AAPJ;AAUE;EACE,cAAA;AARJ;;AAYA;EACE;IACE,oCAAA;EATF;EAWA;IACE,uCAAA;EATF;EAWA;IACE,uCAAA;EATF;AACF;AAcA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,oDAAA;AAZF;;AAeA;EACE,aAAA;EACA,SAAA;AAZF;AAcE;EACE,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AAZJ;AAeE;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAbJ;AAeI;EACE,sBAAA;EACA,mBAAA;AAbN;AAgBI;EACE,yBAAA;AAdN;;AAmBA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBF;AAiBE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAfJ;AAiBE;EACE,yBAAA;AAfJ","sourcesContent":[".transcript {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  position: relative;\n\n  .singleSegment {\n    display: flex;\n    justify-content: flex-start;\n    gap: 8px;\n\n    .counterMarker {\n      margin-top: 8px;\n      font-size: 12px;\n      background-color: #6ba7a8;\n      font-weight: 700;\n      color: #fff;\n      height: 30px;\n      width: 30px;\n      justify-content: center;\n      align-items: center;\n      display: flex;\n      border-radius: 100%;\n\n      &.emptySpeaker {\n        background-color: red;\n      }\n    }\n  }\n}\n.contentWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  @media screen and (min-width: 992px) {\n    display: grid;\n    grid-template-columns: repeat(10, 1fr);\n    gap: 3rem;\n  }\n\n  .transcriptWrapper {\n    order: 2;\n    @media screen and (min-width: 992px) {\n      grid-column: span 7;\n      order: 1;\n    }\n  }\n\n  .sidebar {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    order: 1;\n    @media screen and (min-width: 992px) {\n      grid-column: span 3;\n      order: 2;\n    }\n  }\n}\n\n.mediaWrapper {\n  background-color: #6ba7a8;\n  padding: 8px;\n  border-radius: 12px;\n  z-index: 2;\n  display: flex;\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n  .mediaContainer {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n    .media {\n      width: 100%;\n    }\n    .button{\n      color: #fff;\n      font-weight: 500;\n      cursor: pointer;\n      text-align: center;\n    }\n  }\n  \n}\n\n// Word-level display styles\n.wordLevelDisplay {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem;\n  background-color: transparent;\n  border: none;\n}\n\n.speakerGroup {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.messageNumber {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #6ba7a8;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.messageBubble {\n  background-color: #fafafa;\n  border: 1px solid #6ba7a8;\n  border-radius: 8px;\n  padding: 12px 16px;\n  flex: 1;\n  margin-left: 8px;\n}\n\n.speakerName {\n  font-weight: 600;\n  color: #333;\n  font-size: 0.9rem;\n  margin-bottom: 8px;\n  border-bottom: 1px solid #e0e0e0;\n  padding-bottom: 4px;\n}\n\n.wordsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n  line-height: 1.6;\n}\n\n.word {\n  display: inline-block;\n  padding: 2px 4px;\n  margin: 0 1px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  border-radius: 3px;\n  position: relative;\n  \n  &:hover {\n    background-color: rgba(33, 150, 243, 0.15);\n    transform: translateY(-1px);\n  }\n\n  // Currently playing word (bright highlight)\n  &.wordPlaying {\n    background-color: #2196f3;\n    color: white;\n    font-weight: 500;\n    box-shadow: 0 2px 4px rgba(33, 150, 243, 0.3);\n    transform: translateY(-1px) scale(1.05);\n    animation: pulse 0.5s ease-in-out;\n  }\n\n  // Word being edited\n  &.wordEditing {\n    background-color: #fff3cd;\n    border: 1px solid #ffc107;\n    border-radius: 3px;\n  }\n}\n\n.wordInput {\n  background: transparent;\n  border: none;\n  outline: none;\n  font-size: inherit;\n  font-family: inherit;\n  color: inherit;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  min-width: 20px;\n  \n  &:focus {\n    outline: none;\n  }\n}\n\n// Context Menu\n.contextMenu {\n  position: fixed;\n  z-index: 1000;\n  pointer-events: auto;\n}\n\n.contextMenuContent {\n  background: #1976d2;\n  border-radius: 8px;\n  padding: 8px;\n  display: flex;\n  gap: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  position: relative;\n  \n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 6px solid #1976d2;\n  }\n}\n\n.contextMenuItem {\n  background: transparent;\n  border: none;\n  color: white;\n  padding: 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n  \n  &:hover {\n    background-color: rgba(255, 255, 255, 0.2);\n  }\n  \n  svg {\n    display: block;\n  }\n}\n\n@keyframes pulse {\n  0% {\n    transform: translateY(-1px) scale(1);\n  }\n  50% {\n    transform: translateY(-1px) scale(1.08);\n  }\n  100% {\n    transform: translateY(-1px) scale(1.05);\n  }\n}\n\n// ... existing styles ...\n\n.searchReplacePanel {\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem;\n  background-color: #fff;\n  border-radius: 12px;\n  border: 1px solid #ddd;\n  position: fixed;\n  bottom: 0.5rem;\n  left: 0.5rem;\n  z-index: 1000;\n  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1));\n}\n\n.searchReplaceControls {\n  display: flex;\n  gap: 1rem;\n  \n  input {\n    padding: 0.5rem;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    flex: 1;\n  }\n  \n  button {\n    padding: 0.5rem 1rem;\n    background-color: #6ba7a8;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    \n    &:disabled {\n      background-color: #ccc;\n      cursor: not-allowed;\n    }\n    \n    &:hover:not(:disabled) {\n      background-color: #6ba7a8;\n    }\n  }\n}\n\n.searchReplaceToggle {\n  padding: 0.5rem;\n  background-color: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 999px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  svg{\n    width: 16px;\n    height: 16px;\n    color: #6ba7a8;\n  }\n  &:hover {\n    background-color: #e9ecef;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transcript": `styles_transcript__HJ6jM`,
	"singleSegment": `styles_singleSegment__vxYcO`,
	"counterMarker": `styles_counterMarker__Zyehd`,
	"emptySpeaker": `styles_emptySpeaker__eLpaL`,
	"contentWrapper": `styles_contentWrapper__YKdvH`,
	"transcriptWrapper": `styles_transcriptWrapper__mJ31L`,
	"sidebar": `styles_sidebar__yYOnK`,
	"mediaWrapper": `styles_mediaWrapper__q58UM`,
	"mediaContainer": `styles_mediaContainer__RcEC8`,
	"media": `styles_media__Hf4k+`,
	"button": `styles_button__tjEkL`,
	"wordLevelDisplay": `styles_wordLevelDisplay__toWGk`,
	"speakerGroup": `styles_speakerGroup__cjB2R`,
	"messageNumber": `styles_messageNumber__OBPv4`,
	"messageBubble": `styles_messageBubble__xHUaF`,
	"speakerName": `styles_speakerName__IFYfH`,
	"wordsContainer": `styles_wordsContainer__1IdGJ`,
	"word": `styles_word__iMeIH`,
	"wordPlaying": `styles_wordPlaying__OGLV0`,
	"pulse": `styles_pulse__3CUxh`,
	"wordEditing": `styles_wordEditing__zG0pT`,
	"wordInput": `styles_wordInput__jV8yN`,
	"contextMenu": `styles_contextMenu__1t8yY`,
	"contextMenuContent": `styles_contextMenuContent__dqGuP`,
	"contextMenuItem": `styles_contextMenuItem__68Y3U`,
	"searchReplacePanel": `styles_searchReplacePanel__VyQ2X`,
	"searchReplaceControls": `styles_searchReplaceControls__UqXDm`,
	"searchReplaceToggle": `styles_searchReplaceToggle__hFeHG`
};
export default ___CSS_LOADER_EXPORT___;
